import styled from '@emotion/styled';
import CultureCardList from '@components/_templates/career/CultureCard/list';

const CultureWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 80px;
  padding-bottom: 100px;
  gap: 28px;
`;

const CultureTitle = styled.p`
  font-size: 24px;
  font-style: normal;
  font-weight: 700;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 60px;
  width: 1080px;
`;

export default function Culture() {
  return (
    <>
      <CultureWrapper>
        {/* <CultureTitle>{t('career.cultureTitle')}</CultureTitle> */}
        <CultureTitle>스틸보소 문화</CultureTitle>
        <CultureCardList />
      </CultureWrapper>
    </>
  );
}
